import React from "react";
import { PermissionedRoute } from "./PermissionedRoute";

export function withPermission(
  WrappedComponent: React.ComponentType<any>,
  module: string
) {
  return function WithPermissionWrapper(props: any) {
    return (
      <PermissionedRoute module={module}>
        <WrappedComponent {...props} />
      </PermissionedRoute>
    );
  };
}
